import { useFlags } from "@/hooks/useFeatureFlags";
import { applyDefaultTabHref } from "@/lib/defaultTab";
import { Link, Path, useNavigate } from "@/router";
import { createElement, type ComponentProps, type MouseEvent } from "react";

type DefaultTabLinkProps = ComponentProps<typeof Link>;

function shouldInterceptDefaultTabClick(event: MouseEvent<HTMLAnchorElement>): boolean {
  return (
    !event.defaultPrevented &&
    event.button === 0 &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.shiftKey &&
    !event.altKey
  );
}

export default function DefaultTabLink(props: DefaultTabLinkProps) {
  const navigate = useNavigate();
  const enabled = useFlags()?.["backoffice-navigation-preferences"] === true;

  return createElement(Link, {
    ...props,
    onClick: (event: MouseEvent<HTMLAnchorElement>) => {
      props.onClick?.(event);
      if (!enabled || !shouldInterceptDefaultTabClick(event)) {
        return;
      }

      const href = event.currentTarget.getAttribute("href");
      if (!href) {
        return;
      }

      const next = applyDefaultTabHref(href);
      if (next === href) {
        return;
      }

      event.preventDefault();
      navigate(next as Path);
    }
  } as DefaultTabLinkProps);
}
